"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSDevSection = void 0;
const syntax_highlight_json_1 = require("@app/util/syntax-highlight-json");
const react_1 = __importDefault(require("react"));
const calendar_settings_context_1 = require("../../calendar-settings-context");
const CSDevSection = () => {
    const { options, getValues } = (0, calendar_settings_context_1.useCalendarSettingsContext)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(syntax_highlight_json_1.SyntaxHighlightJSON, { json: JSON.stringify({
                form: getValues(),
                options,
            }) })));
};
exports.CSDevSection = CSDevSection;
